import script from "./movements-policy-list.vue?vue&type=script&setup=true&lang=js"
export * from "./movements-policy-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__